import { startOfDay } from 'date-fns';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnChanges,
  OnInit,
  Renderer2,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import {
  MatCalendar,
  MatCalendarCellClassFunction,
} from '@angular/material/datepicker';
import { CalendarService } from './services/calendar.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  SelDate!: any;
  SelMonth: any;
  SelYear: any;
  isLoader: boolean = false;
  calendarData: any[] = [];
  currentYear: number = new Date().getFullYear();
  states: { id: string; name: string; code: string }[] = [];
  selectedState: string = '';
  holidays: any = {};
  holiday_exist: boolean = false;
  selectedDate: Date | null = null;
  selectedDateReason: string = '';
  months: { name: string; date: Date }[] = [];
  selectedMonth: Date = new Date();
  maxDate: Date = new Date();

  @ViewChild(MatCalendar, { static: false }) calendar!: MatCalendar<Date>;

  constructor(
    private calendarService: CalendarService,
    private cdr: ChangeDetectorRef,
    private el: ElementRef,
    private renderer: Renderer2
  ) {}

  ngOnInit(): void {
    const today = new Date();
    this.selectedDate = today;
    this.getReasonForDate(today);
    this.calendarService.getCalendarData().subscribe((data) => {
      this.calendarData = data[0].calendar.filter(
        (item: { year: number }) => item.year >= this.currentYear
      );
      this.states = data[0].states;

      if (this.states.length > 0) {
        this.selectedState = this.states[0].code;
        this.onStateChange();
      }

      this.generateMonths();
    });
  }

  generateMonths(): void {
    const monthNames = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ];

    this.months = monthNames.map((monthName, index) => ({
      name: `${monthName} ${this.currentYear}`,
      date: new Date(this.currentYear, index, 1),
    }));
    this.maxDate = new Date(this.currentYear, 11, 31);
  }

  onStateChange(): void {
    // const today = new Date();
    // this.selectedDate = today;
    this.selectedDate = null;
    if (this.selectedState) {
      const stateData = this.states.find(
        (state) => state.code === this.selectedState
      );
      if (stateData) {
        const stateId = stateData.id;
        const currentYearData = this.calendarData.find(
          (item) => item.year === this.currentYear
        );
        if (currentYearData && currentYearData.holidays[stateId]) {
          this.holidays = currentYearData.holidays[stateId];
        } else {
          this.holidays = [];
        }
        this.cdr.markForCheck(); // Schedule change detection
        this.calendar?.updateTodaysDate(); // Optional, force calendar refresh
        let newStateDate = this.selectedDate;
        if (newStateDate != null)
          this.selectedDateReason = this.getReasonForDate(newStateDate);
      }
    } else {
      this.holidays = [];
    }
  }

  isHoliday(date: Date): boolean {
    const month = date.getMonth() + 1;
    const day = date.getDate();
    if (this.holidays[month]) {
      return this.holidays[month].some(
        (holiday: any) => parseInt(holiday.date) === day
      );
    }
    return false;
  }

  isSecondOrFourthSaturday(date: Date): boolean {
    const dayOfWeek = date.getDay();
    if (dayOfWeek !== 6) {
      // Check if it's Saturday
      return false;
    }

    const day = date.getDate();
    const month = date.getMonth();
    const year = date.getFullYear();
    const firstDay = new Date(year, month, 1).getDay();
    let saturdayCount = 0;

    for (let i = 1; i <= day; i++) {
      const d = new Date(year, month, i);
      if (d.getDay() === 6) {
        saturdayCount++;
      }
    }

    return saturdayCount === 2 || saturdayCount === 4;
  }

  holidayDateClass: MatCalendarCellClassFunction<Date> = (cellDate, view) => {
    if (view === 'month') {
      let className = '';
      debugger;
      // Check if it's a Sunday
      if (cellDate.getDay() === 0) {
        className += 'saturday-date'; // Add 'sunday-red' class for Sundays
      }
      if (cellDate.getDay() === 0 && this.isHoliday(cellDate)) {
        className += 'holiday-date ';
      }
      // Existing logic for holidays and second/fourth Saturdays
      if (this.isHoliday(cellDate)) {
        className += 'holiday-date ';
      }
      if (this.isSecondOrFourthSaturday(cellDate)) {
        className += 'saturday-date ';
      }
      if (
        this.selectedDate &&
        cellDate.getTime() === this.selectedDate.getTime()
      ) {
        className += 'selected-date ';
      }

      return className.trim();
    }
    return '';
  };

  onDateSelect(date: Date | null): void {
    if (date) {
      this.selectedDate = date;
      this.selectedDateReason = this.getReasonForDate(date);
      this.cdr.markForCheck();
    } else {
      this.selectedDate = null;
      this.selectedDateReason = '';
    }
    this.calendar.updateTodaysDate(); // Force calendar refresh
  }

  getReasonForDate(date: Date): string {
    if (!date || !this.holidays) return '';
    const month = date.getMonth() + 1;
    const day = date.getDate();
    this.SelDate = date.getDate();
    this.SelYear = date.getFullYear();
    this.SelMonth = date.toLocaleString('default', { month: 'long' });
    if (this.holidays[month]) {
      const holiday = this.holidays[month].find(
        (h: any) => parseInt(h.date) === day
      );
      if (holiday) {
        this.holiday_exist = true;
        return holiday.Reason_EN;
      }
    }
    this.holiday_exist = false;
    return '';
  }

  onMonthChange(selectedMonth: Date) {
    this.selectedDateReason = '';
    this.SelMonth = '';
    this.SelDate = '';
    this.SelYear = '';
    this.holiday_exist = false;
    this.selectedMonth = selectedMonth;
    // this.calendar._goToDateInView(
    //   new Date(this.currentYear, selectedMonth.getMonth(), 1),
    //   'month'
    // );
    let newDate = new Date(this.currentYear, selectedMonth.getMonth(), 1);

    // Navigating to the specified month view
    this.calendar._goToDateInView(newDate, 'month');

    this.selectedDateReason = this.getReasonForDate(newDate);
    // Ensure no date is selected
    // this.calendar.selected = null;
    this.cdr.markForCheck();
  }
}
